/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { UnitDependencies } from './dependenciesUnitClass.generated.js';
import { NodeDependencies } from './dependenciesNode.generated.js';
import { createSymbolNode } from '../../factoriesAny.js';
export var SymbolNodeDependencies = {
  UnitDependencies,
  NodeDependencies,
  createSymbolNode
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesSymbolNode.generated.js
// module id = 133
// module chunks = 2